import React, { Fragment } from 'react';
import { Card, Heading, Divider, Grid, View, CheckboxField } from '@aws-amplify/ui-react';
import { RehazieleItem } from './index';

const RehazieleCard1 = (props) => {
    // console.log(props.rehazieleStamm);
    if (!props.rehazieleStamm) {
        return null;
    }

    const handleChange = (e) => {
        // console.log(e)
        const name = e.target.name.split('_');
        const id = parseInt(name[0]);
        const stammid = parseInt(name[1]);
        const rehaziel = props.rehaziele.filter(f => f.ID === id);
        const value = e.target.checked ? parseInt(name[2]) : 0;
        const text = rehaziel.length > 0 ? rehaziel[0].hasOwnProperty('TEXT') ? rehaziel[0].TEXT : '' : '';

        const newRehaziel = { 'ID': id, 'STAMMID': stammid, 'WERT': value, 'TEXT': text }
        // console.log('changed rehaziele', newRehaziele);
        props.handleChange(newRehaziel);
    }

    return (
        <Card variation="elevated">
            <Grid
                columnGap='0.5rem'
                rowGap='0.5rem'
                templateColumns={{ base: "1fr 13fr 1fr 1fr" }}
            >
                <View columnStart={1} columnEnd={2}>
                    <Heading level={3}>Rehaziele</Heading>
                </View>
                <View columnStart={3} textAlign={'center'} backgroundColor='#dddad1'>
                    Weniger wichtig
                </View>
                <View columnStart={4} textAlign={'center'} backgroundColor='#dddad1'>
                    Sehr wichtig
                </View>
                {props.rehazieleStamm.filter(f => f.EBENE === 1 && f.STAMMID === props.hook).map((item, i) =>
                    <Fragment key={i}>
                        <View columnStart={1} columnEnd={-1}><Divider /></View>
                        <View key={i + '0'} columnSpan={2}><Heading level={5} key={i + '0a'}>{item.BEZEICHNUNG}</Heading></View>
                        <View key={i + '1'} columnStart={3} textAlign={'center'} backgroundColor='#dddad1'>
                            <CheckboxField
                                name={item.ID + '_' + item.STAMMID + '_1'}
                                key={'I1' + i}
                                label='&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;'
                                labelPosition="start"
                                onClick={handleChange}
                                isDisabled={props.readOnly}
                                checked={props.rehaziele.length > 0 ? props.rehaziele.filter(f => f.ID === item.ID).length > 0 ? props.rehaziele.filter(f => f.ID === item.ID)[0].WERT === 1 ? true : false : false : false}
                            />
                        </View>
                        <View key={i + '2'} columnStart={4} textAlign={'center'} backgroundColor='#dddad1'>
                            <CheckboxField
                                name={item.ID + '_' + item.STAMMID + '_2'}
                                key={'I2' + i}
                                label='&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;'
                                labelPosition="start"
                                onClick={handleChange}
                                isDisabled={props.readOnly}
                                checked={props.rehaziele.length > 0 ? props.rehaziele.filter(f => f.ID === item.ID).length > 0 ? props.rehaziele.filter(f => f.ID === item.ID)[0].WERT === 2 ? true : false : false : false}
                            />
                        </View>
                        <RehazieleItem
                            rehazieleStamm={props.rehazieleStamm.filter(u => u.STAMMID === item.ID && u.EBENE === 2)}
                            key={"EV_" + i}
                            handleChange={props.handleChange}
                            readOnly={props.readOnly}
                            rehaziele={props.rehaziele ? props.rehaziele.filter(v => v.STAMMID === item.ID) : []}
                        />
                    </Fragment>
                )}
            </Grid>
        </Card >
    );
}
export default RehazieleCard1;